import { webUtils } from '@ustra/core'
import { NuxtMiddleware, Context } from './nuxt-middleware'

export default {
  name: 'auth',
  middleware: async (_context: Context) => {
    const appProp = _context.$ustra.env.appProp
    const { config } = _context.app

    const isCheckAuth = config && config.auth?.required

    // if (appProp.app.auth.customAuthCheckModule) {
    //   const customAuthCheckModule = require(appProp.app.auth.customAuthCheckModule)
    //   console.info('customAuthCheckModule', customAuthCheckModule)
    // }

    // cookie를 사용하지 않는 경우, client에서만 처리를 수행한다.
    if (appProp.app.auth.type === 'jwt' && !appProp.app.auth.jwt.useCookie && !webUtils.isBrowser()) {
      await _context.$ustra.auth.store.setNeedAuthCheckClient(isCheckAuth)
      return
    }

    await _context.$ustra.store.auth().applyToken(_context)

    // 인증이 필요한 경우
    if (isCheckAuth && !_context.$ustra.store.auth().authenticated) {
      _context.$ustra.auth.doFailureAuth(_context.route, false)
      // _context.$auth.goLoginPage()
    }

    // custom 체킹 모듈
    if (_context.$ustra.auth && isCheckAuth) {
      const customCheckModuleFunction = _context.$ustra.auth.getCheckModuleFunction()

      if (customCheckModuleFunction && typeof customCheckModuleFunction === 'function') {
        const result = await customCheckModuleFunction(_context, config)

        if (!result) {
          _context.$ustra.auth.doFailureAuth(_context.route, false)
        }
      }
    }
  },
} as NuxtMiddleware
